import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isString } from 'lodash';
import { Typography, Grid } from '@emburse/embark-core';
function DataGridHeader({ title, titleRight, subtitle, subtitleRight }) {
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, children: [isString(title) && _jsx(Typography, { variant: "h4", children: title }), !isString(title) && title, _jsx(Grid, { item: true, style: { marginLeft: 'auto' }, children: titleRight })] }), _jsxs(Grid, { container: true, children: [isString(subtitle) && _jsx(Typography, { variant: "h6", children: subtitle }), !isString(subtitle) && subtitle, _jsx(Grid, { item: true, style: { marginLeft: 'auto' }, children: subtitleRight })] })] }));
}
DataGridHeader.defaultProps = {
    titleRight: null,
    subtitle: '',
    subtitleRight: null
};
export default DataGridHeader;
